module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image8-c767661abd086db08cdd198b35c57d90.jpg";